import { render, staticRenderFns } from "./CategoryNavbar.vue?vue&type=template&id=0126cf40&scoped=true&"
import script from "./CategoryNavbar.vue?vue&type=script&lang=ts&"
export * from "./CategoryNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryNavbar.vue?vue&type=style&index=0&id=0126cf40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0126cf40",
  null
  
)

export default component.exports